import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Combination } from '@shared/interfaces/combination/combination.interface';
import {
  CombinationFilter,
  CombinationFilterValues
} from '@shared/interfaces/combination/combination-filters/combination-filters.interface';
import { Page } from '@shared/interfaces/pagination/page.interface';
import { Paging } from '@shared/interfaces/pagination/paging.interface';
import { HomeService } from '@shared/service/home/home.service';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { userCombinations } from './user-combinations.actions';

@Injectable()
export class UserCombinationsEffects {
  loadTableData = createEffect(() =>
    this.actions$.pipe(
      ofType(userCombinations.loadTableDataAndFilters),
      switchMap((payload: { options: CombinationFilter; paging: Paging }) =>
        this.homeService.getCombinationsWithFilters(payload.options, payload.paging).pipe(
          map((response: [Page<Combination>, CombinationFilterValues]) =>
            userCombinations.loadTableAndDataFiltersSuccess({
              page: response[0],
              filters: response[1]
            })
          ),
          catchError(() => of(userCombinations.cleanUpTableData()))
        )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly homeService: HomeService
  ) {}
}
